import { configureStore } from "@reduxjs/toolkit";

import listviewReducer from "./slice/listviewSlice";
import postSliceReducer from "./slice/postSlice";
import getSliceReducer from "./slice/getSlice";
export const store = configureStore({
    reducer:{
     listview: listviewReducer,
     postSlice:postSliceReducer,
     getSlice:getSliceReducer,
    }
})

